import type { AxiosError, AxiosRequestConfig } from 'axios';

import { httpRequest } from '@/services/httpRequest';

import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import { createApi } from '@reduxjs/toolkit/query/react';

interface QueryError {
  status: number | undefined;
  data: object | string;
}

export const axiosQueryWrapper = async (config: AxiosRequestConfig) => {
  try {
    return await httpRequest(config);
  } catch (axiosError) {
    const error = axiosError as AxiosError;
    return {
      error: {
        status: error.response?.status,
        data: error.response?.data || error.message,
      },
    };
  }
};

export const basePublicQuery =
  (): BaseQueryFn<AxiosRequestConfig, unknown, QueryError> => async (args) => {
    return await axiosQueryWrapper(args);
  };

export const baseProtectedQuery =
  (): BaseQueryFn<AxiosRequestConfig, unknown, QueryError> => async (args, api) => {
    const result = await axiosQueryWrapper(args);

    if ('error' in result && result.error && result.error.status === 401) {
      api.dispatch({ type: 'auth/logout' });
    }

    return result;
  };

export const baseProtectedApi = createApi({
  reducerPath: 'baseProtectedApi',
  baseQuery: baseProtectedQuery(),
  endpoints: () => ({}),
  tagTypes: [
    'Policy',
    'PolicyList',
    'PolicyGroup',
    'PolicyGroupList',
    'PolicyGroupUsers',
    'AvailableUsers',
  ],
});

export const basePublicApi = createApi({
  reducerPath: 'basePublicApi',
  baseQuery: basePublicQuery(),
  endpoints: () => ({}),
  tagTypes: [],
});
